export const emailUs = 'mailto:connect@nensinformatics.com';

export const scheduleCallUrl = 'https://calendly.com/connect-nensinformatics/30min';

export const scheduleCall = () => {
  window.open(scheduleCallUrl, '_blank');
};
